<template>
  <dx-modal
    :value="show"
    @input="close"
    title="Logs de Webhook"
    size="md"
    id="mxmed-webhook-logs-modal"
  >
    <p class="text-gray modal-desc">Histórico de entregas dos últimos 30 dias.</p>

    <div class="loading loading-lg" v-if="loading"></div>
    <template v-else>
      <div class="empty" v-if="items.length === 0">
        <p class="empty-title h5">Nenhum log encontrado</p>
        <p class="empty-subtitle">Ainda não há registros de webhook nos últimos 30 dias.</p>
      </div>
      <table class="table" v-else>
        <thead>
          <tr>
            <th style="width: 150px;">Data/hora</th>
            <th style="width: 80px;">Status</th>
            <th>Mensagem</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in items"
            :key="index"
            :class="{ 'text-error': item.statusCode !== 200 }"
          >
            <td class="text-nowrap">{{ item.timestamp | date('datetime') }}</td>
            <td>
              <span
                class="label"
                :class="item.statusCode === 200 ? 'label-success' : 'label-error'"
              >
                {{ item.statusCode }}
              </span>
            </td>
            <td>{{ item.message || '--' }}</td>
          </tr>
        </tbody>
      </table>
    </template>

    <template v-slot:footer>
      <button class="btn" @click="close">Fechar</button>
    </template>
  </dx-modal>
</template>

<script>
import api from '../api';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  watch: {
    show(val) {
      if (val) this.load();
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const data = await api.webhook.findLogs();
        this.items = data.items || [];
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

#mxmed-webhook-logs-modal {
  .modal .modal-desc {
    margin-bottom: $layout-spacing-lg;
  }

  .modal .table tr.text-error td {
    background: lighten($error-color, 48%);
  }
}
</style>
